<template>
  <div class="main resources" style="margin-bottom: 40px">
    <div>
      <p class="resources-title">{{ $t('r-title1') }}</p>
      <div class="bar"></div>
      <div class="white-paper">
        <img src="../../assets/images/20180419/Crait_Resource_03.png" alt="" @click="download">
        <img src="../../assets/images/20180419/Crait_Resource_05.png" alt="" class="click-to-download" @click="download">
      </div>
    </div>
    <div class="blogs">
      <p class="resources-title">{{ $t('r-title2') }}</p>
      <div class="bar"></div>
      <div class="blogs-part1">
        <div><img src="../../assets/images/20180419/Crait_Resource_09.png" alt=""></div>
        <div class="blogs-right">
          <p class="resources-sub-title">{{ $t('subtitle1') }}</p>
          <div>
            <p class="resources-third-title">{{ $t('detail1') }}</p>
          </div>
          <div class="read-more"><a href="https://medium.com/@craitapp/introducing-crait-e3ac2c22d133" target="_blank">{{ $t('readmore1') }}</a></div>
        </div>
      </div>
      <div class="blogs-part2">
        <div><img src="../../assets/images/20180419/Crait_Resource_12.jpeg" alt=""></div>
        <div class="blogs-right">
          <p class="resources-sub-title">{{ $t('subtitle2') }}</p>
          <div>
            <p class="resources-third-title">{{ $t('detail2') }}</p>
          </div>
          <div class="read-more"><a href="https://medium.com/@craitapp/data-breach-trends-f77db653fd78" target="_blank">{{ $t('readmore1') }}</a></div>
        </div>
      </div>
      <div class="blogs-part3">
        <div><img src="../../assets/images/20180419/Crait_Resource_14.jpeg" alt=""></div>
        <div class="blogs-right">
          <p class="resources-sub-title">{{ $t('subtitle3') }}</p>
          <div>
            <p class="resources-third-title">{{ $t('detail3') }}</p>
          </div>
          <div class="read-more"><a href="https://medium.com/@craitapp/small-enterprises-are-easy-targets-a48bd23856cb" target="_blank">{{ $t('readmore1') }}</a></div>
        </div>
      </div>
    </div>
    <div class="read-more-btn">
      <a href="https://medium.com/@craitapp" target="_blank">{{ $t('readmore2') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('resources'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  data () {
    return {}
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    download () {
      let self = this
      self.$message({
        duration: 1000,
        message: 'Download is about to begin...',
        type: 'success'
      })
      let a = document.createElement('a')
      a.target = '_blank'
      a.href = '/data/Revised-white-paper.pdf'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>
<style lang="scss">
  .resources {
    padding: 1rem 2.6rem 0;
    @media screen and (min-width: 760px) and (max-width: 1440px) {
      padding: 1rem .6rem 0;
    }
    @media screen and (max-width: 760px) {
      padding: 1rem .3rem 0;
      margin-top: 0 !important;
    }
    .bar {
      @media screen and (max-width: 760px){
        width: 0.6rem;
        height: 0.03rem;
        background-color: #e7345e;
        margin: 0.2rem auto 0 !important;
      }
    }
    .resources-title {
      font-size: 0.5rem;
      color: #323232;
      font-weight: bold;
      text-align: center;
      @media screen and (max-width: 760px) {
        font-size: .4rem;
      }
    }
    .white-paper {
      margin: 1rem 0;
      @media screen and (max-width: 760px) {
        margin: .5rem 0;
      }
      position: relative;
      img {
        box-shadow: #888888 0 2px 20px;
        @media screen and (max-width: 760px) {
          width: 100%;
        }
      }
      .click-to-download {
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
        opacity: 0;
        @media screen and (max-width: 760px) {
          display: none;
        }
      }
      .click-to-download:hover {
        opacity: 0.8;
      }
    }
    .blogs {
      > div {
        margin-top: 0.5rem;
        display: flex;
        @media screen and (max-width: 760px) {
          display: block;
        }
        > div {
          flex: 1;
          @media screen and (max-width: 760px) {
            flex: inherit;
          }
          img {
            max-width: 100%;
            max-height: 100%;
            width: 100%;
            height: 100%;
          }
          .resources-sub-title {
            font-size: 0.3rem;
            color: #323232;
            font-weight: bold;
            @media screen and (max-width: 760px) {
              font-size: .24rem;
            }
          }
          .resources-third-title {
            font-size: 0.24rem;
            color: #999;
            margin-top: 0.4rem;
            @media screen and (max-width: 760px) {
              font-size: .17rem;
            }
          }
          .read-more {
            font-size: 0.24rem;
            cursor: pointer;
            margin-top: 0.85rem;
            a {
              text-decoration: none;
              color: #5ea2ec;
            }
            @media screen and (max-width: 760px) {
              margin-top: .1rem !important;
            }
          }
        }
      }
      .blogs-part2 {
        .blogs-right {
          margin-top: 1.2rem;
          .resources-sub-title {
            @media screen and (max-width: 760px) {
              font-size: .19rem;
            }
          }
          .resources-third-title {
            @media screen and (min-width: 760px) and (max-width: 1440px) {
              margin-top: 0.67rem;
            }
          }
        }
      }
      .blogs-part3 {
        .blogs-right {
          margin-top: .98rem;
          .resources-third-title {
            margin-top: 0.2rem;
          }
          .read-more {
            margin-top: 0.22rem;
          }
        }
      }
      .blogs-right {
        margin-left: 0.8rem;
        margin-top: 0.7rem;
        @media screen and (max-width: 760px) {
          margin-left: 0;
        }
      }
    }
    .read-more-btn {
      width: 2.8rem;
      height: 0.42rem;
      margin: 1.15rem auto 0;
      background-color: #5ea2ec;
      font-size: 0.24rem;
      text-align: center;
      border-radius: 0.03rem;
      cursor: pointer;
      a {
        text-decoration: none;
        color: #fff;
      }
      @media screen and (max-width: 760px) {
        margin-top: .7rem;
        width: 2.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Resources.vue?32f48378